<template>
    <div class="user-management">
      <div class="d-flex wrap gap-10">

        <div class="d-flex">
          <label class="mr5">字典标签</label>
          <el-input
            class="input200"
            v-model="queryParams.name"
            :placeholder="`请输入`"
            clearable
          ></el-input>
        </div>

        <el-button
          class="ml10"
          type="primary"
          size="small"
          @click="search"
        >查询</el-button>
  
        <el-button v-if="user.is_super_tenant_admin" size="small" icon="el-icon-plus" type="primary" @click="openCreate()">新建</el-button>

        <el-button v-if="user.is_super_tenant_admin" size="small" icon="el-icon-delete" type="danger" @click="batchDelete()">删除</el-button>
      </div>
  
      <div class="page-card">
        <el-table
          class="mt10"
          border
          ref="list"
          :data="list">
          <el-table-column type="selection"></el-table-column>

          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column
            v-for="(item) in headers"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :width="item.width">
            <template slot-scope="scope">
              <template v-if="item.prop === 'handle'">

                <el-tooltip effect="dark" v-if="btnDisabled(scope.row)" :content="`编辑`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click="openEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>

                <el-tooltip effect="dark" v-if="btnDisabled(scope.row)" :content="`删除`" placement="top-start">
                    <el-button class="p0 fontsize20" type="text" @click="deleteDict(scope.row)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
  
              </template>
              <!-- <inputNumber v-else-if="item.prop === 'order'" v-model="scope.row[item.prop]"></inputNumber> -->
              <inputNumber v-else-if="item.prop === 'order'" @change="inputBlur($event,scope.row)" :value.sync="scope.row[item.prop]" :min="0" :step="1" :step-strictly="true" :controls="false" :placeholder="`请输入`"></inputNumber>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <pagination :queryParams="queryParams" :getList="getList" /> -->
      </div>
  
      <edit
        ref="Edit"
        @fresh="getList"
      />
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex';
  import Edit from './components/edit.vue';
  import inputNumber from '@/components/form/inputNumber.vue';

  import {
    sysOptionDetailList,
    sysOptionDelete,
    sysOptionBatchDelete,
    sysOptionUpdateSort
  } from '@/api.js'; 
  import {
    pageSize
  } from '@/utils/Config.js';
  export default {
    name: 'DictType',
    components: {
      Edit,
      inputNumber
    },
    computed: {
      ...mapGetters([ 'user' ]),
    },
    data() {
      return {
        queryParams: {
          pageIndex: 1,
          pageSize,
          _total: 0,
          type: undefined
        },
        headers: [],
        list: [],
      }
    },
    methods: {
      getList() {
        const {
          order,
          orderBy,
          type,
          name
        } = this.queryParams
        const query = {
          order,
          order_column: orderBy,
          type,
          name
        }
        const url = sysOptionDetailList.replace('{type}', this.queryParams.type)
        this.$request('get', url, query)
        .then(res => {
          if (res) {
            const {
              data,
              columns,
              total
            } = res
            
            this.list = data
            this.headers = this.$utils.generateColumns(columns)
            this.queryParams._total = total
          }
        })
      },
      search() {
        this.queryParams.pageIndex = 1
        this.getList()
      },
      openCreate() {
        // 新增
        const {
          Edit
        } = this.$refs
  
        Edit && Edit.open({
          tenant_text:''
        })
      },
      openEdit(detail) {
        // 编辑
        const {
          Edit
        } = this.$refs
        const {
          id,
          type
        //   tenant_text
        } = detail
        Edit && Edit.open({ id,type })
      },
      back() {
        this.$router.go(-1)
      },
      async batchDelete() {
        const { list } = this.$refs
        const { selection } = list
        if (!selection || !selection.length) {
            this.$message.error(`请选择需要删除的数据`)

            return
        }
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        }).then(() => {
          const ids = selection.map(i => i.id)
          const obj = { ids }
          this.$request('post',sysOptionBatchDelete,obj).then((res) => {
            if (res == 0) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getList()
            }
          })
        })
      },
      deleteDict({id}) {
        // TODO
        // 确认删除吗？
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = sysOptionDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res == 0) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getList()
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      btnDisabled(row) {
        if (this.user.role_id === 1 || this.user.role_id === 5) {
          return true
        }
        if (row.can_customize === 1) {
          return true
        }
        return false
      },
      inputBlur(value,row) {
        const url = sysOptionUpdateSort + `/${row.id}`
        this.$request('post',url, {sort: value}).then((res) => {
          if (res == 0) {
            // 字典排序更新成功
            this.$message.success(`操作成功`)
            this.getList()
          }
        })
      }
    },
    created() {
      this.queryParams.type = (this.$route.params.id || this.$route.params.id == 0) && JSON.parse(this.$route.params.id)
      this.getList()
    }
  }
  </script>
  
  <style>
  
  </style>